import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { NavController, NavParams } from 'ionic-angular';
import { ContactPage, Plotter, ecgDataService} from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { settingsPage } from '../pages/settings/settings';
import { NavPage} from '../pages/nav/nav';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AngularFireModule, AuthProviders, AuthMethods, AngularFire } from 'angularfire2';
import { FirebaseStorageProvider } from "../providers/firebase-storage-provider"
import {groupsPage} from '../pages/groups/groupsPage';
import {MyDashboardPage} from '../pages/dashboard/my-dashboard/my-dashboard';
import {joinGroupPage} from '../pages/groups/joinGroup/joinGroupPage';
import {personPage} from '../pages/person/person';
import {LeaderDashBoardPage} from '../pages/leader-dash-board/leader-dash-board';

import {MenuPage } from '../pages/menu/menu'
import {TimelinePage } from '../pages/Timeline/Timeline'
import { AddLogPage} from '../pages/add-log/add-log';
import { logModel} from "../model/logsModel"
import {groupModel} from "../model/groupModel";
import {personModel, statsRecord, teamModel} from "../model/personModel";
import {appState } from "../model/appState";

import {ShowActivityLogsPage} from "../pages/show-activity-logs/show-activity-logs";
import {groupProfilePage} from "../pages/groupProfile/group-profile.page";

import { RouterModule, Routes } from '@angular/router';   
 
// Core Modules
import {CoreModule} from './core/core.module'; 

// Feature modules
import {userModule} from './feature/loginModule/user.module';

// Shared modules
import {UiCommonModule} from './shared/ui/ui.common.module'
// Initialize Firebase
var firebaseConfig ={
    apiKey: "AIzaSyCSaoo4v3aTMIruypdr3xdCzmqGldYxNsc",
        authDomain: "banditrunners-a84ee.firebaseapp.com",
            databaseURL: "https://banditrunners-a84ee.firebaseio.com",
                storageBucket: "banditrunners-a84ee.appspot.com",
                    messagingSenderId: "1025351629142"
};
if (window.location.host.indexOf('neelsoftware.ddns.net') >= 0) {
    firebaseConfig = {
        apiKey: "AIzaSyBrjqtC3CKcTBmlGos0YJWS8A2_M8Bhfxk",
        authDomain: "iotapps-1edde.firebaseapp.com",
        databaseURL: "https://iotapps-1edde.firebaseio.com",
        storageBucket: "iotapps-1edde.appspot.com",
        messagingSenderId: "356866603802"
    };
};
const myFirebaseAuthConfig = {
    provider: AuthProviders.Anonymous,
    method: AuthMethods.Anonymous
};

const appRoutes: Routes = [
    { path: 'app', component: NavPage },
    { path: 'login', loadChildren: './feature/loginModule/user.module#userModule?sync=true' },
    { path: '', loadChildren: './feature/loginModule/user.module#userModule?sync=true' },
    
];

@NgModule({
    imports: [
        CoreModule,
        UiCommonModule,
        userModule,
        RouterModule.forRoot(appRoutes),
        IonicModule.forRoot(MyApp),
        ChartsModule, 
        AngularFireModule.initializeApp(firebaseConfig, myFirebaseAuthConfig) 

    ],
  declarations: [
    MyApp,
    
      ContactPage, Plotter,
    HomePage,
      TabsPage, NavPage, settingsPage,  groupsPage, personPage, joinGroupPage, MyDashboardPage, AddLogPage,
      ShowActivityLogsPage, LeaderDashBoardPage, MenuPage, groupProfilePage, TimelinePage
  ],
  
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    
      ContactPage, Plotter,
    HomePage,
      TabsPage, NavPage, settingsPage,  groupsPage, personPage, joinGroupPage, MyDashboardPage, AddLogPage,
      ShowActivityLogsPage, LeaderDashBoardPage, MenuPage, groupProfilePage, TimelinePage
  ],
  providers: [{ provide: ErrorHandler, useClass: IonicErrorHandler }, ecgDataService, FirebaseStorageProvider, AngularFire, groupModel, appState,
      personModel, logModel, statsRecord, teamModel
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts